export const PROJEKT_SORTIERUNGEN = [
    { id: 'bearbeitet', label: 'Zuletzt bearbeitet' },
    { id: 'angelegt', label: 'Zuletzt angelegt' },
    { id: 'name', label: 'Name A–Z' },
];
export function istProjektSortierung(x) {
    return x === 'bearbeitet' || x === 'angelegt' || x === 'name';
}
const zeit = (s) => (s ? Date.parse(s) || 0 : 0);
const nachName = (a, b) => a.name.localeCompare(b.name, 'de', { numeric: true, sensitivity: 'base' });
export function sortiereProjekte(projekte, art) {
    const liste = [...projekte];
    if (art === 'name')
        return liste.sort(nachName);
    const feld = art === 'angelegt' ? 'created_at' : 'updated_at';
    return liste.sort((a, b) => zeit(b[feld]) - zeit(a[feld]) || nachName(a, b));
}
//# sourceMappingURL=projektSortierung.js.map